/* eslint-disable */
export const buildUrl = (url, {page, search, sort, status, limit}) => {
  if (status) {
    url = url + (url.indexOf('?') === -1 ? '?' : '&') + `status=${status}`;
  }
  if (limit) {
    url = url + (url.indexOf('?') === -1 ? '?' : '&') + `limit=${limit}`;
  }
  if (page || page === 0) {
    url = url + (url.indexOf('?') === -1 ? '?' : '&') + `page=${page + 1}`;
  }

  if (sort) {
    url =
      url +
      (url.indexOf('?') === -1 ? '?' : '&') +
      `sortBy=${sort.sortBy}&sort=${sort.sort}`;
  }

  if (search) {
    url = url + (url.indexOf('?') === -1 ? '?' : '&') + `search=${search}`;
  }

  return url;
};
